import React, { JSX, useEffect, useState } from "react";

import {
    Layout,
    Typography,
    Button,
    Spin,
} from "antd";

import {
    FileSearchOutlined,
    ReloadOutlined,
    LoadingOutlined,
} from "@ant-design/icons";

import UserNavbar from "../UserNavbar";
import Sider from "antd/es/layout/Sider";
import { Content, Footer } from "antd/es/layout/layout";

import Statistics from "./Statistics";
import { ViewTable } from "./ViewTable";

const { Title, Text } = Typography;

const ViewTickets = (): JSX.Element => {

    /*
     * --------------------------------------------------
     * Loading
     * --------------------------------------------------
     */
    const [loading] = useState(false);

    /*
     * --------------------------------------------------
     * Responsive sidebar
     * --------------------------------------------------
     */
    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 830
    );

    const [isOnClickSlider] = useState(false);

    /*
     * --------------------------------------------------
     * Refresh key
     * --------------------------------------------------
     */
    const [refreshKey, setRefreshKey] = useState(0);

    const refreshData = () => {
        setRefreshKey((prev) => prev + 1);
    };

    /*
     * --------------------------------------------------
     * Selected status
     *
     * This value is used by the ViewTable status
     * dropdown.
     * --------------------------------------------------
     */
    const [selectedStatus, setSelectedStatus] =
        useState<string | undefined>(undefined);

    /*
     * --------------------------------------------------
     * Status selected from Statistics card
     * --------------------------------------------------
     */
    const handleStatusSelect = (
        status: string | undefined
    ) => {

        setSelectedStatus(status);

    };

    /*
     * --------------------------------------------------
     * Responsive handling
     * --------------------------------------------------
     */
    useEffect(() => {

        const handleResize = () => {

            setIsMobile(
                window.innerWidth < 830
            );

        };

        window.addEventListener(
            "resize",
            handleResize
        );

        return () => {

            window.removeEventListener(
                "resize",
                handleResize
            );

        };

    }, []);

    /*
     * --------------------------------------------------
     * UI
     * --------------------------------------------------
     */
    return (
        <>
            {/* Global loading indicator */}
            {loading && (
                <Spin
                    spinning
                    indicator={
                        <LoadingOutlined
                            style={{
                                fontSize: 48,
                            }}
                            spin
                        />
                    }
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        zIndex: 999,
                    }}
                />
            )}

            <Layout
                style={{
                    minHeight: "89vh",
                }}
            >

                {/* --------------------------------------------------
                    Sidebar
                -------------------------------------------------- */}

                <Sider
                    collapsed={
                        isMobile
                            ? true
                            : isOnClickSlider
                    }
                    collapsedWidth={50}
                    style={{
                        background: "#fff",
                        overflow: "auto",
                        paddingTop: 20,
                    }}
                >
                    <UserNavbar />
                </Sider>

                <Layout>

                    {/* --------------------------------------------------
                        Main Content
                    -------------------------------------------------- */}

                    <Content
                        style={{
                            margin: "16px 16px 0",
                        }}
                    >

                        <div
                            style={{
                                padding: 6,
                            }}
                        >

                            {/* --------------------------------------------------
                                Page Header
                            -------------------------------------------------- */}

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    marginBottom: 24,
                                    gap: 16,
                                }}
                            >

                                {/* Icon + Title */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 12,
                                    }}
                                >

                                    <FileSearchOutlined
                                        style={{
                                            fontSize: 40,
                                            color: "#1677ff",
                                            flexShrink: 0,
                                        }}
                                    />

                                    <div>

                                        <Title
                                            level={3}
                                            style={{
                                                margin: 0,
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            My Tickets
                                        </Title>

                                        <Text
                                            type="secondary"
                                        >
                                            View and track all your submitted
                                            support requests.
                                        </Text>

                                    </div>

                                </div>

                                {/* Refresh button */}
                                <Button
                                    icon={
                                        <ReloadOutlined />
                                    }
                                    onClick={() =>
                                        window.location.reload()
                                    }
                                >
                                    Refresh
                                </Button>

                            </div>


                            {/* --------------------------------------------------
                                Statistics
                            -------------------------------------------------- */}

                            <div
                                style={{
                                    marginBottom: 24,
                                }}
                            >

                                <Statistics
                                    refreshKey={
                                        refreshKey
                                    }
                                    onStatusSelect={
                                        handleStatusSelect
                                    }
                                />

                            </div>


                            {/* --------------------------------------------------
                                Ticket Table
                            -------------------------------------------------- */}

                            <div>

                                <div
                                    style={{
                                        borderRadius: 12,
                                        boxShadow:
                                            "0 2px 8px rgba(0,0,0,0.06)",
                                    }}
                                >

                                    <ViewTable
                                        refreshData={
                                            refreshData
                                        }

                                        selectedStatus={
                                            selectedStatus
                                        }

                                        onStatusChange={
                                            setSelectedStatus
                                        }
                                    />

                                </div>

                            </div>

                        </div>

                    </Content>


                    {/* --------------------------------------------------
                        Footer
                    -------------------------------------------------- */}

                    <Footer
                        style={{
                            textAlign: "center",
                        }}
                    >
                        ©2025 Copyright: C-DAC Mumbai.
                        All Rights Reserved
                    </Footer>

                </Layout>

            </Layout>
        </>
    );
};

export default ViewTickets;